import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './redux';
import App from './App';
import 'fontsource-montserrat/800.css';
import 'fontsource-montserrat/700.css';
import 'fontsource-montserrat/600.css';
import 'fontsource-montserrat/400.css';
import 'fontsource-montserrat/500.css';

import './i18n';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
